import { observer } from 'mobx-react-lite';
import React, { useCallback, useRef } from 'react';
import { basedAxios } from '../../../store/Store';

const EventQuantizer = ({ disabled = false, onChange, eventId, order, quantity, sqlStateNo, ...rest }) => {
  const inputRef = useRef(null);
  const timeout = React.useRef(null);

  const checkAvailableStatus = async count => {
    try {
      const orderId = order?.orderId;

      const { data } = await basedAxios.get(
        `./attendee/status/${eventId}${orderId && orderId > 0 ? '/' + orderId : ''}?sqlStateNo=${sqlStateNo ? sqlStateNo : 0}&count=${count}`
      );

      return data.available;
    } catch (error) {
      return false;
    }
  };

  const handleDecrement = async () => {
    if (disabled) return;

    const newQuantity =
      inputRef.current?.value && parseInt(inputRef.current.value) <= parseInt(quantity) ? parseInt(inputRef.current.value) : parseInt(quantity);

    const available = await checkAvailableStatus(newQuantity - 1);

    if (!available) {
      alert('Event does that have enough tickets');
      return;
    }

    if (quantity > 0) {
      inputRef.current.value = newQuantity - 1;
      onChange(newQuantity - 1);
    }
  };

  const handleIncrement = async () => {
    if (disabled) return;

    const newQuantity =
      inputRef.current?.value && parseInt(inputRef.current.value) > parseInt(quantity) ? parseInt(inputRef.current.value) : parseInt(quantity);

    const available = await checkAvailableStatus(newQuantity + 1);

    if (!available) {
      alert('Event does that have enough tickets');
      return;
    }

    inputRef.current.value = newQuantity + 1;
    onChange(newQuantity + 1);
  };

  const handleValueChange = async e => {
    if (disabled) return;

    if (timeout.current !== null) {
      clearTimeout(timeout.current);
    }

    const count = parseInt(e.target.value);

    if (quantity === count) {
      inputRef.current.value = parseInt(quantity);
      return;
    }

    try {
      const available = await checkAvailableStatus(count);

      if (!available) {
        inputRef.current.value = quantity < count ? quantity : 0;
        alert('Event does that have enough tickets');
        return;
      }

      timeout.current = setTimeout(() => {
        onChange(inputRef.current.value);
        inputRef.current.value = count;
      }, 1500);
    } catch (error) {}
  };

  return (
    <div className="flex gap-x-2 items-center my-4 ml-0 w-8">
      <button className="rounded-full h-4 w-4 p-2.5 flex justify-center bg-transparent items-center border border-[rgba(0,0,0,0.2)]" onClick={handleDecrement}>
        <i className="ri ri-subtract-line" />
      </button>

      <input
        ref={inputRef}
        type="number"
        className="w-12 border border-zinc-200 rounded-md p-[5px_!important] text-sm text-center qnty-input"
        defaultValue={quantity ? parseInt(quantity) : 0}
        onChange={handleValueChange}
      />
      <button className="rounded-full h-4 w-4 p-2.5 flex justify-center bg-transparent items-center border border-[rgba(0,0,0,0.2)]" onClick={handleIncrement}>
        <i className="ri ri-add-line" />
      </button>
    </div>
  );
};

export default observer(EventQuantizer);
